export const LorenSession = {
  assetsViewsKey: "loren-assets-views",
  channelsKey: "loren-channels",
  currentChannelKey: "loren-current-channel",
  dashboardViewTypeKey: "loren-dashboard-view-type",
  dashboardWidgetsKey: "loren-dashboard-widgets",
  groups: "loren-groups",
  lastSelectedLanguageKey: "loren-language",
  mapPreference: "map-preference",
  selectedAssets: "loren-selected-assets",
  sessionKey: "session-plain",
  impersonatorSessionKey: "session-impersonator",
  userPassedTour: "loren-passed-tour",
};
